export default __webpack_public_path__ + "static/media/first.f6ff728d.png";